const basicText = /^[\s]*[\S]+[\s\S]*$/; // At least 1 non-whitespace character, leading + trailing whitespace is allowed
const email = /^\s*\S+[@]\S+[.]\S+\s*$/; // <love>@<money>.<beta>, leading + trailing whitespace is allowed
const hex = /^#[A-Fa-f0-9]{6}$/; // Hex code
const phone = /^\+?\s*\d[\d\s]*$/; // At least 1 number, no letters, spaces allowed, optional '+' at start

const regex = {
  basicText,
  email,
  hex,
  phone
};

export default regex;
